import { useAuth0 } from "@auth0/auth0-react";
import { LogOut } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import Typography from "@/components/ui/typography";

const UnsupportedRole = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full p-8 flex flex-col items-center gap-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-brand-purple/10 text-brand-purple rounded-full">
          <Typography
            size="sh2"
            className="text-brand-purple font-bold"
            as="span"
          >
            S
          </Typography>
        </div>
        <div className="space-y-2">
          <Typography size="h2">Access Restricted</Typography>
          <Typography size="b2" className="text-muted-foreground">
            This application currently only supports licensee accounts. Expert
            and admin features are not available at this time.
          </Typography>
        </div>
        <Button
          variant="ghost"
          className="flex items-center gap-2"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" />
          <Typography size="l2" as="span">
            Logout
          </Typography>
        </Button>
      </Card>
    </div>
  );
};

export default UnsupportedRole;
